<h1 class="h3 mb-2 text-gray-800">Doctores</h1>
<!-- <p class="mb-4">DataTables is a third party plugin that is used to generate the demo table below. For more information
    about DataTables, please visit the <a target="_blank" href="https://datatables.net">official DataTables
        documentation</a>.</p> -->

<!-- DataTales Example -->
<div class="card shadow mb-4">
    <div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary">Formulario de Doctores</h6>
    </div>
    <div class="card-body">
        <form name="form" (ngSubmit)="f.form.valid && guardarDatos()" #f="ngForm">
            <div class="form-group">
                <label>Código</label>
                <input type="text" class="form-control" name="codigo" #codigo="ngModel" [(ngModel)]="doctor.codigo"
                    required [ngClass]="{'is-invalid':  f.submitted && codigo.invalid}" />
                <div *ngIf="f.submitted && codigo.invalid" class="invalid-feedback">
                    <div *ngIf="codigo.errors.required">El número es requerido
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label>Nombre</label>
                <input type="text" class="form-control" name="fullname" #fullname="ngModel"
                    [(ngModel)]="doctor.fullname" required
                    [ngClass]="{'is-invalid':  f.submitted && fullname.invalid}" />
                <div *ngIf="f.submitted && fullname.invalid" class="invalid-feedback">
                    <div *ngIf="fullname.errors.required">El nombre es requerido
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label>Correo Electrónico</label>
                <input type="email" class="form-control" name="email" #email="ngModel" [(ngModel)]="doctor.email"
                    required [ngClass]="{'is-invalid':  f.submitted && email.invalid}" />
                <div *ngIf="f.submitted && email.invalid" class="invalid-feedback">
                    <div *ngIf="email.errors.required">El email es requerido
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label>Contraseña</label>
                <input type="password" disabled="{{mantenerPass}}" #password="ngModel" class="form-control" name="password"
                    [(ngModel)]="doctor.password" required
                    [ngClass]="{'is-invalid':  f.submitted && password.invalid}" />
                <div *ngIf="f.submitted && password.invalid" class="invalid-feedback">
                    <div *ngIf="password.errors.required">La contraseña es requerida
                    </div>
                </div>
            </div>
            <div class="form-group" *ngIf="mostrarMantenerPass">
                <div class="form-check">
                    <input type="checkbox" class="form-check-input" name="mantenerPass" id="mantenerPass"
                        [(ngModel)]="mantenerPass" (change)="cambiarContrasenaChecked()" />
                    <label class="form-check-label" for="archivos">¿Mantener contraseña?</label>
                </div>
            </div>
            <div class="form-group">
                <label>Teléfono</label>
                <input type="phone" class="form-control" name="telefono" #telefono="ngModel"
                    [(ngModel)]="doctor.telefono" required
                    [ngClass]="{'is-invalid':  f.submitted && telefono.invalid}" />
                <div *ngIf="f.submitted && telefono.invalid" class="invalid-feedback">
                    <div *ngIf="telefono.errors.required">El teléfono es requerido
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label>Ciudad</label>
                <input type="text" class="form-control" name="ciudad" #ciudad="ngModel" [(ngModel)]="doctor.ciudad"
                    required [ngClass]="{'is-invalid':  f.submitted && ciudad.invalid}" />
                <div *ngIf="f.submitted && ciudad.invalid" class="invalid-feedback">
                    <div *ngIf="ciudad.errors.required">La ciudad es requerida
                    </div>
                </div>
            </div>
            <div class="form-group">
                <button type="submit" class="btn btn-primary">Guardar Datos</button>
                <a routerLink="/doctores" class="btn btn-link">Volver</a>
            </div>
        </form>
    </div>
</div>